module.exports = __webpack_public_path__ + "img/jwgl-htgl-xtsz.e1b4de80.png";